import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Inspection } from '../../models/index';

@Component({
    selector: 'models-list',
    templateUrl: './models-list.component.html',
    standalone: false
})
export class InspectionModelListComponent {
  @Input() public inspections: Inspection[];
  public selectedInspection: Inspection;
  @Output() public toggleSelectInspection: EventEmitter<any> = new EventEmitter();
  public selection: any = {};
  orderByFieldName: string = 'name';
  direction: string = 'asc';
  @Input() query: string = '';
  errorMessage: string;

  public loading: Boolean = true;

  constructor() {}

  public selectInspection(inspection: Inspection) {
    this.selectedInspection = inspection;
    this.toggleSelectInspection.emit(inspection);
  }

  public setOrderBy(newOrderBy: string) {
    this.direction = this.orderByFieldName == newOrderBy ? (this.direction == 'asc' ? 'desc' : 'asc') : 'desc';
    this.orderByFieldName = newOrderBy;
  }
}
